/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'house': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M27.996 26h2a1 1 0 110 2h-28a1 1 0 010-2h2V14.442a2.004 2.004 0 01.655-1.48l10-9.091a1.992 1.992 0 012.69 0l10 9.091a2.005 2.005 0 01.655 1.48V26zm-10-.001h1v-6a1 1 0 00-1-1h-4a1 1 0 00-1 1v6h1V26h4v-.001z" _fill="#0B2C62"/>'
  }
})
